import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export class TwinfieldTestService extends BaseService<any> {
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        'ngInject';
        super(Restangular, AppService, 'twinfield/test');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/twinfieldTest.service.ts